import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cce934ae&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cce934ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce934ae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShimmerEffect: require('/workspace/components/ShimmerEffect.vue').default,EventCardGeneral: require('/workspace/components/EventCardGeneral.vue').default})
